import { render, staticRenderFns } from "./SloganText.vue?vue&type=template&id=bcbb9870&"
import script from "./SloganText.vue?vue&type=script&lang=js&"
export * from "./SloganText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports